import axios from 'axios';

const api = axios.create({
  baseURL:'https://dikota.ao/backend/api'
  //baseURL: 'http://localhost/INFOSI/dikota/api'

});

export default api;